import { useDispatch } from "react-redux";
import { updateRiderUniformCoverageAmount } from "../../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice";
import { formatAmountType } from "../../../../../../utils/format-numbers.utils";
import { PROPOSAL_RIDERS } from "../../../../../../constant/gms-constant";
import CheckboxRiderGDR from "./checkbox-rider-GDR";
import { CheckedGreen } from "../../../../../../assets/icon/svg";
import { SelectedRider } from "../../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.state";
import Input from "../../../../../ui/input";
import { customStyle, defaultStyle } from "../../../../../../constant/custom-style";
import { UniformCoverageRiderItem } from "../../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.state";
import { SubTypeOption } from "../../../../../../api/gms/group-category/group-category-api-state";

interface Props {
    riderLabel?: string;
    rider: SelectedRider;
    isPreview?: boolean;
    selectUniformCoverageRidersState: UniformCoverageRiderItem[]
    selectedCoverageTypeState: SubTypeOption | null
}

export default function AttachableRiderInputUniformCoverage({ selectUniformCoverageRidersState, selectedCoverageTypeState, rider, isPreview }: Props) {
    
    const dispatch = useDispatch();
    const isUniformCoverage: boolean = selectedCoverageTypeState?.name === "Uniform Coverage";

    const riderSubtitle: Record<number, string> = {
        8: "Enter an amount between 100 and 200.",
        9: "Enter an amount of 500 or higher.",
        14: "Enter an amount of 500 or higher.",
        13: "Select either 1 or 2 units.",
        16: "Enter only 10,000, 20,000, or 30,000.",
        19: "Enter only 10,000, 20,000, or 30,000.",
    };

    const uniformRider = selectUniformCoverageRidersState?.find(r => r.id === rider.id);
    const value = uniformRider?.rider?.fAmount || 0;

    return (
        <tr className="group transition-colors hover:bg-blue-50/30">
            <td className="sticky left-0 z-30 min-w-[160px] lg:min-w-[300px] border-b border-gray-200 bg-white px-4 py-3 shadow-[4px_0_10px_rgba(0,0,0,0.03)] group-hover:bg-blue-50">
                <div className="flex min-w-0 items-start gap-2">
                    {isPreview && (
                        <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-500 text-white">
                            <CheckedGreen />
                        </div>
                    )}
                    <div className="flex min-w-0 flex-col gap-1">
                        <span className="break-words font-medium text-gray-800">
                            {rider.label}
                        </span>
                        {!isPreview && riderSubtitle[rider.id] && (
                            <span className="text-[10px] leading-4 text-gray-500">
                                {riderSubtitle[rider.id]}
                            </span>
                        )}
                    </div>
                </div>
            </td>

            {isUniformCoverage && (
                <td className="min-w-[160px] border-b border-l border-gray-200 px-2 py-1">
                    {Object.values(PROPOSAL_RIDERS.GDR.productFor).some((id) => id === rider.id) ? (
                        <div className="flex min-h-[36px] items-center justify-center">
                            <CheckboxRiderGDR 
                                amount={value} 
                                isPreview={isPreview} 
                                rider_id={rider.id} 
                                onChange={(value) => {
                                dispatch(updateRiderUniformCoverageAmount({
                                        riderId: rider.id,
                                        fAmount: value
                                    }));
                                }} 
                            />
                        </div>
                    ) : (
                        <Input 
                            type="text" 
                            value={formatAmountType(value)} 
                            readonly={isPreview} 
                            disabled={isPreview} 
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${(value === 0 || !value) ? '' : customStyle }`}
                            onChange={(e) => {
                                if (isPreview) return;
                                const rawValue = e.target.value.replace(/,/g, '');
                                const newSalary = Number(rawValue) || 0;
                                dispatch(updateRiderUniformCoverageAmount({
                                    riderId: rider.id,
                                    fAmount: newSalary
                                }));
                            }} 
                        />
                    )}
                </td>
            )}
        </tr>
    )
}
